import {useRef, useState} from "react";
import {AnimatePresence, motion} from "framer-motion";

import {IconLibrary, ThriveIcon, BasicButton, IconButton } from "thrive-components";

import {formatDateToDDMMYYYYHHMM} from "../../../helpers/Dates.ts";
import {IUserGroupSyncHistory} from "../../../api/UserGroupSync";

import {UserGroupSyncService} from "./UserGroupSync.service.ts";

import {useClickAwayClose} from "../../hooks/utility/useClickAwayClose.ts";



const InfoPill = ({iconName, size, content, iconColor}: {iconName?: IconLibrary, size?: string, content: string, iconColor?: string}) => {
    return ( <li className={'info-pill'}>
        {!!iconName && <ThriveIcon iconName={iconName} sizeInPx={size} color={iconColor}/>}
        <p>{content}</p>
    </li>)
}

const HistoryItem = ({item, UGSS, isLastItem}: {item: IUserGroupSyncHistory, UGSS: UserGroupSyncService, isLastItem: boolean}) => {

    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const handleCompleteSync = async (id: string) => {
        const success = await UGSS.completeSync(id);

        if (success) {
            await UGSS.refreshHistory();
        }
    }

    useClickAwayClose(menuOpen, menuRef, () => setMenuOpen(false));

    return <li id={`listItem-${item.id}`} className="user-group-sync-list-item">
        <div className={'user-group-sync-list-item-title-row'}>
            <div className={'title-wrapper'}>
                <h3>{item.fileName}</h3>
                <span className={`badge ${item.status}`}>{item.status}</span></div>
            <div className={'user-group-sync-list-item-additional-actions'} ref={menuRef}>

                <IconButton
                    iconName={IconLibrary.MENU}
                    onButtonClick={() => setMenuOpen(!menuOpen)}
                    ariaLabel={'Show additional actions'}
                />
                <AnimatePresence>
                    {menuOpen && (
                        <motion.div
                            className={'additional-actions-context-menu'}
                            initial={{ opacity: 0, height: 0, top: 0 }}
                            animate={{ opacity: 1, height: 'fit-content', top: '35px' }}
                            exit={{ opacity: 0, height: 0, top: 0 }}
                        >
                            {UGSS.canViewDiff(item.status) &&
                                <BasicButton
                                    content={<div className="user-group-sync-icon-button-wrapper">
                                        <span>Download Diff</span>
                                        <ThriveIcon iconName={IconLibrary.DOWNLOAD} sizeInPx={'14'} color={"var(--thriveGreyDark"} />
                                    </div>}
                                    ariaLabel={'View Diff'}
                                    isLink={true}
                                    linkUrl={`/api/user-group-sync/${item.id}/diff`}
                                    openInNewTab={true}
                                />
                            }
                            {UGSS.canComplete(item.status) &&
                                <BasicButton
                                    className={'success-button'}
                                    content={<div className="user-group-sync-icon-button-wrapper">
                                        <span>Complete Group Sync </span>
                                        <ThriveIcon iconName={IconLibrary.CIRCLE_CHECK} sizeInPx={'14'} color={"var(--thriveGreen)"} />

                                    </div>}
                                    ariaLabel={'Complete'}
                                    onButtonClick={() => handleCompleteSync(String(item.id))}
                                />
                            }
                        </motion.div>
                    )}
                </AnimatePresence>

            </div>

        </div>
        <div className={'user-group-sync-list-item-meta-info-row'}>

            <span>{formatDateToDDMMYYYYHHMM(item.createdAt)}</span>
            {!!item.createdByDisplayName && <>
                <span>-</span>
                <span>{item.createdByDisplayName}</span>
            </>}
        </div>
        {item.failureReason
            ? <p style={{color: 'var(--thriveRed)'}}>{item.failureReason}</p>
            : <ul className={'user-group-sync-list-details-row'}>
                <InfoPill
                    iconName={IconLibrary.PERSON}
                    size={'12'}
                    content={`${item.usersProcessed} users processed`}
                    iconColor={'var(--thriveCMSTextEmphasisColor)'}
                />
                <InfoPill
                    iconName={IconLibrary.USERS}
                    size={'12'}
                    content={`${item.groupsCreated} groups created`}
                    iconColor={'var(--thriveCMSTextEmphasisColor)'}
                />
                <InfoPill
                    size={'12'}
                    content={`➕ ${item.userGroupsAdded} added`}
                />
                <InfoPill
                    size={'12'}
                    content={`➖ ${item.userGroupsRemoved} removed`}
                />
                <InfoPill
                    size={'12'}
                    content={`🚫 ${item.usersExcluded} users / ${item.groupsExcluded} groups excluded`}
                />
            </ul>
        }

        {!isLastItem && <hr />}
    </li>
}

export default HistoryItem